import { ServicePortfolioType } from '../../enums/ServicePortfolioType';
import { TrimResource } from '../../types/service-portfolio/ClientActivationFormResource';
import { ConquestResource } from '../../types/service-portfolio/ConquestResource';
import {
  CustomerDetail,
  UpdateCustomerProfileResource,
} from '../../types/service-portfolio/CustomerDetail';
import { ServicePortfolioRequestResource } from '../../types/service-portfolio/ServicePortfolioRequestResource';
import {
  ServiceCustomerDetail,
  ServicePortfolioResource,
} from '../../types/service-portfolio/ServicePortfolioResource';
import { ServicePortfolioResponseResource } from '../../types/service-portfolio/ServicePortfolioResponseResource';
import { UpdateGreetedResource } from '../../types/service-portfolio/UpdateGreetedResource';
import { UpdateOutreachResource } from '../../types/service-portfolio/UpdateOutreachResource';
import { GetOneFromPath, Post, PostWithReturn, PostWithVoidReturn } from '../api/GenericClient';

const initialPath = '/service';
const recentType = 'recents';

async function fetchServicePortfolioData(
  postData: ServicePortfolioRequestResource,
  type: ServicePortfolioType,
): Promise<ServicePortfolioResponseResource> {
  const dashboardType =
    type === ServicePortfolioType.RecentService ? recentType : type.toLocaleLowerCase();
  const path = `/dashboard/${dashboardType}`;
  const apiPath = initialPath.concat(path);
  const response = await Post<ServicePortfolioResponseResource>(apiPath, postData);
  return response;
}

async function fetchServicePortfolioCountData(type: ServicePortfolioType): Promise<number> {
  const dashboardType =
    type === ServicePortfolioType.RecentService ? recentType : type.toLocaleLowerCase();
  const path = `/dealCount/${dashboardType}`;
  const apiPath = initialPath.concat(path);
  const response = await GetOneFromPath<number>(apiPath);
  return response;
}

async function getServiceCustomerDetails(
  dealerId: string,
  vin: string,
  isServiceAppointment: boolean,
): Promise<ServiceCustomerDetail> {
  const path = `/customer?dealerId=${dealerId}&vin=${vin}&isServiceAppointment=${isServiceAppointment}`;
  const apiPath = initialPath.concat(path);

  return await GetOneFromPath(apiPath);
}

async function getNoReplacementCustomerDetails(
  dealerId: string,
  customerNumber: string,
): Promise<CustomerDetail> {
  const path = `/noReplacementcustomer?dealerId=${dealerId}&customerNumber=${customerNumber}`;
  const apiPath = initialPath.concat(path);

  return await GetOneFromPath(apiPath);
}

async function saveServiceCustomerDetails(
  data: { customerBase: {}; vin: string },
  dealerId: string,
  type: ServicePortfolioType,
): Promise<Response> {
  const dashboardType =
    type === ServicePortfolioType.RecentService ? recentType : type.toLocaleLowerCase();
  const path = `/updateconquest/${dashboardType}?dealerId=${dealerId}`;
  const apiPath = initialPath.concat(path);

  return await PostWithReturn(apiPath, data);
}

async function saveNoReplacementCustomerDetails(
  data: UpdateCustomerProfileResource,
  dealerId: string,
  type: ServicePortfolioType,
): Promise<Response> {
  const dashboardType =
    type === ServicePortfolioType.RecentService ? recentType : type.toLocaleLowerCase();
  const path = `/updateNoReplacementCustomer/${dashboardType}?dealerId=${dealerId}`;
  const apiPath = initialPath.concat(path);

  return await PostWithReturn(apiPath, data);
}

async function updateOutreach(
  data: UpdateOutreachResource,
  type: ServicePortfolioType,
): Promise<void> {
  const dashboardType =
    type === ServicePortfolioType.RecentService ? recentType : type.toLocaleLowerCase();
  const path = `/updateOutreach/${dashboardType}`;
  const apiPath = initialPath.concat(path);

  return await PostWithVoidReturn(apiPath, data);
}

async function updateGreeted(
  data: UpdateGreetedResource,
  type: ServicePortfolioType,
): Promise<void> {
  const dashboardType =
    type === ServicePortfolioType.RecentService ? recentType : type.toLocaleLowerCase();
  const path = `/updateInteraction/${dashboardType}`;
  const apiPath = initialPath.concat(path);

  return await PostWithVoidReturn(apiPath, data);
}

async function activateServiceCustomer(
  data: ConquestResource,
  type: ServicePortfolioType,
  brandId: string,
): Promise<Response> {
  const dashboardType =
    type === ServicePortfolioType.RecentService ? recentType : type.toLocaleLowerCase();
  const path = `/activate/${dashboardType}?brandId=${brandId}`;
  const apiPath = initialPath.concat(path);

  return await PostWithReturn(apiPath, data);
}

async function getTrimsByVin(vin: string, dealerId: string): Promise<Array<TrimResource>> {
  const apiPath = `/common/trimsByVin?vin=${vin}&dealerId=${dealerId}`;

  return await GetOneFromPath(apiPath);
}

async function validationForActivation(vin: string): Promise<boolean> {
  const path = `/validateForActivation?vin=${vin}`;
  const apiPath = initialPath.concat(path);

  return await GetOneFromPath(apiPath);
}

async function getServiceRecordType(vin: string, dealerId: string): Promise<ServicePortfolioType> {
  const path = `/recordType?dealerId=${dealerId}&vin=${vin}`;
  const apiPath = initialPath.concat(path);

  return await GetOneFromPath(apiPath);
}

async function getSpecificServiceRecord(
  vin: string,
  dealerId: string,
  type: ServicePortfolioType,
): Promise<Array<ServicePortfolioResource>> {
  const dashboardType = type.toLocaleLowerCase();
  const path = `/specificDeal/${dashboardType}?dealerId=${dealerId}&vin=${vin}`;
  const apiPath = initialPath.concat(path);

  return await GetOneFromPath(apiPath);
}

export const ServicePortfolioService = {
  getServiceCustomerDetails,
  fetchServicePortfolioData,
  saveServiceCustomerDetails,
  fetchServicePortfolioCountData,
  updateOutreach,
  updateGreeted,
  activateServiceCustomer,
  getTrimsByVin,
  getServiceRecordType,
  getSpecificServiceRecord,
  getNoReplacementCustomerDetails,
  saveNoReplacementCustomerDetails,
  validationForActivation,
};
